import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ModalBanksEmmiter {

	constructor() {
	}

	public click = new EventEmitter<any>();
}


// WEBPACK FOOTER //
// ./src/services/modal-banks.service.ts